module.exports = __webpack_public_path__ + "h5/img/master_19.01a7e47a.jpg";